import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useIntl } from 'react-intl';

import { Button } from '@/components/Button';

export const AccountDeletionModal = ({ setOpenDeletionModal, onDeleteHandler }) => {
  const [deletionSteps, setDeletionSteps] = useState(1);
  const { formatMessage } = useIntl();

  return createPortal(
    <>
      <div
        className="fixed z-[50] w-full h-full opacity-60 bg-brand-neutral-800"
        onClick={() => setOpenDeletionModal(false)}
      />
      <div
        className="z-50 fixed top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 bg-brand-neutral-700 p-5 rounded-md md:w-auto w-96"
        aria-modal="true"
      >
        {deletionSteps === 1 ? (
          <div className="md:m-6 text-center md:text-left text-lg">
            <h2 className="mb-3">{formatMessage({ id: 'account.delete.alert.title' })}</h2>
            <p className="text-base my-2 mx-10 text-brand-neutral-300 leading-relaxed font-normal">
              {formatMessage({ id: 'account.delete.alert.description' })}
            </p>
            <div className="flex flex-col md:flex-row justify-center md:my-6 md:gap-3">
              <Button
                onClick={() => setOpenDeletionModal(false)}
                ariaLabel={formatMessage({ id: 'account.delete.accessibility.abort' })}
              >
                {formatMessage({ id: 'account.delete.alert.abort' })}
              </Button>
              <Button
                style="danger"
                onClick={() => setDeletionSteps(2)}
                ariaLabel={formatMessage({ id: 'account.delete.accessibility.continue' })}
              >
                {formatMessage({ id: 'account.delete.alert.confirm' })}
              </Button>
            </div>
          </div>
        ) : (
          <div className="w-full md:m-6 text-center md:text-left text-lg">
            <h2 className="mb-3">{formatMessage({ id: 'account.delete.confirm.title' })}</h2>
            <p className="text-base my-5 mx-10 text-brand-neutral-300 leading-relaxed">
              {formatMessage({ id: 'account.delete.confirm.description' })}
            </p>
            <div className="flex flex-col md:flex-row justify-center md:my-6 md:gap-3">
              <Button
                onClick={() => setOpenDeletionModal(false)}
                ariaLabel={formatMessage({ id: 'account.delete.accessibility.abort' })}
              >
                {formatMessage({ id: 'account.delete.alert.abort' })}
              </Button>

              <Button
                style="danger"
                onClick={() => onDeleteHandler(true)}
                ariaLabel={formatMessage({ id: 'account.delete.accessibility.confirm' })}
              >
                {formatMessage({ id: 'account.delete.alert.confirm' })}
              </Button>
            </div>
          </div>
        )}
      </div>
    </>,
    document.getElementById('genericPortal')
  );
};
